import axios from "axios";

const api = axios.create({
    baseURL:"https://ingreentech.ir/back/public/api/v1"
});


// قبل از ارسال درخواست
api.interceptors.request.use((config)=>{

    const token = localStorage.getItem("token");
    if(token){
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;

});


// بعد از جواب سرور
api.interceptors.response.use(

    (response)=>{
        return response;
    },
    (error)=>{
        if(error.response?.status === 401){
            localStorage.removeItem("token");
            window.location.href="/userAccount";
        }
        return Promise.reject(error);
    }
);


export default api;